import { CplRequestSummaryItem } from "./cpl-request-summary-item.model";
import { CplRequestItem } from "./cpl-request-item.model";

export class CplRequestBasicData {
    RequestID: string;
    PortalID: number;
    Title: string;

    constructor(RequestID: string, PortalID: number, Title: string) {
        this.RequestID = RequestID;
        this.PortalID = PortalID;
        this.Title = Title;
    }

    static BasicsFromCplRequestSummaryItem(request: CplRequestSummaryItem) {
        return new CplRequestBasicData(request.RequestID, request.PortalID, request.Title)
    }

    static BasicsFromCplRequestItem(requestItem: CplRequestItem) {
        return new CplRequestBasicData(requestItem.RequestID, requestItem.PortalID, requestItem.Title);
    }
}